import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const IntellectualProperty = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            All content on the Topibro Technologies website — including but not
            limited to text, graphics, logos, icons, images, audio clips,
            digital downloads, and software — is the property of Topibro
            Technologies or its content suppliers and is protected by applicable
            intellectual property laws. The compilation of all content on this
            site is the exclusive property of Topibro Technologies.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Client Work Product.</b> Upon full payment of all applicable
            fees, Topibro Tech assigns to the client all rights, title, and
            interest in the custom deliverables (such as custom code or design
            assets) created specifically for that client under a project
            agreement, unless the agreement expressly states otherwise.
            Pre-existing tools, frameworks, libraries, and methodologies used in
            developing deliverables remain the property of Topibro Tech and are
            licensed to the client on a non-exclusive basis.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Restricted Use.</b> You may not reproduce, duplicate, copy, sell,
            resell, or exploit any portion of our website or services without
            express written permission from Topibro Technologies. Unauthorized
            use of any trademark, logo, or service mark belonging to Topibro
            Technologies is strictly prohibited.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Feedback.</b> If you submit ideas, suggestions, or feedback
            regarding our services, you grant Topibro Tech an irrevocable,
            perpetual, worldwide, royalty-free licence to use, reproduce, and
            incorporate that feedback into our products and services without any
            obligation to you.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="intellectual-property">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Intellectual Property
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default IntellectualProperty;
